export default function handleChangeGeneral(event, setState) {
	if (event.target.type === "text") {
		setState((prevState) => {
			return { ...prevState, [event.target.name]: event.target.value };
		});
	} else if (event.target.type === "email") {
		setState((prevState) => {
			return { ...prevState, [event.target.name]: event.target.value };
		});
	} else if (event.target.type === "textarea") {
		setState((prevState) => {
			return { ...prevState, [event.target.name]: event.target.value };
		});
	} else if (event.target.type === "date") {
		if (event.target.value) {
			let newDate = event.target.value ? new Date(event.target.value).toISOString() : null;

			setState((prevState) => {
				return { ...prevState, [event.target.name]: newDate };
			});
		} else {
			setState((prevState) => {
				return { ...prevState, [event.target.name]: null };
			});
		}
	} else if (event.target.type === "checkbox") {
		let check;
		if (event.target.name == "AUSILIONUOVO") {
			check = event.target.checked ? "S" : "N";
		} else if (event.target.name == "ASTER_MANCATARITCONS") {
			check = event.target.checked ? "S" : "N";
		} else {
			check = event.target.checked ? "T" : "F";
		}

		setState((prevState) => {
			return { ...prevState, [event.target.name]: check };
		});
	} else if (event.target.type === "select-one") {
		setState((prevState) => {
			return { ...prevState, [event.target.name]: event.target.value };
		});
	} else if (event.target.type === "radio") {
		setState((prevState) => {
			return { ...prevState, [event.target.name]: event.target.value };
		});
	}
	return;
}

export function handleChangeReducer(event) {
	//vedo se event è effettivamente un evento o un valore
	if (event.target === undefined) {
		return event;
	}

	if (
		event.target.type === "text" ||
		event.target.type === "email" ||
		event.target.type === "textarea"
	) {
		return { [event.target.name]: event.target.value };
	} else if (event.target.type === "date") {
		if (event.target.value) {
			let newDate = event.target.value ? new Date(event.target.value).toISOString() : null;

			return { [event.target.name]: newDate };
		} else {
			return { [event.target.name]: null };
		}
	} else if (event.target.type === "checkbox") {
		let check;
		if (event.target.name === "AUSILIONUOVO") {
			check = event.target.checked ? "S" : "N";
		} else if (event.target.name === "ASTER_MANCATARITCONS") {
			check = event.target.checked ? "S" : "N";
		} else {
			check = event.target.checked ? "T" : "F";
		}

		return { [event.target.name]: check };
	} else if (event.target.type === "select-one") {
		return { [event.target.name]: event.target.value };
	} else if (event.target.type === "radio") {
		return { [event.target.name]: event.target.value };
	}
	return;
}
